// Onboarding progress indicator. Renders `total` dots, with the active
// dot expanded and all preceding dots filled.

import { C } from "../theme.js";

export function ProgressDots({ step, total }) {
  return (
    <div style={{ display: "flex", gap: 6, justifyContent: "center", marginBottom: 28 }}>
      {Array.from({ length: total }).map((_, i) => (
        <div key={i} style={{
          width: i === step ? 22 : 8, height: 8, borderRadius: 99,
          background: i <= step ? C.green : C.border,
          transition: "all .3s ease",
        }} />
      ))}
    </div>
  );
}
